export enum UserActionTypeArea {
  AlternateEmailChanged = 'AlternateEmailChanged',
  ArchiveOptionsChanged = 'ArchvieOptionsChanged',
  AutoActivationMode = 'AutoActivationMode',
  BackupConfigured = 'BackupConfigured',
  BackupDeleted = 'BackupDeleted',
  BackupOptionsChanged = 'BackupOptionsChanged',
  SharedDrivesBackupOptions = 'SharedDrivesBackupOptions',
  ContentViewed = 'ContentViewed',
  DefaultRetentionPolicyChanged = 'DefaultRetentionPolicyChanged',
  Deletion = 'Deletion',
  Downloaded = 'Downloaded',
  EditEmailReportSettings = 'EditEmailReportSettings',
  EmailReportSettingsChanged = 'EmailReportSettingsChanged',
  Export = 'Export',
  ExportSettingsChanged = 'ExportSettingsChanged',
  PageVisited = 'PageVisited',
  PermissionsSet = 'PermissionsSet',
  Restore = 'Restore',
  RetentionPolicyChanged = 'RetentionPolicyChanged',
  SettingsChanged = 'SettingsChanged',
  StorageChanged = 'StorageChanged',
  StorageDeleted = 'StorageDeleted',
  TaskPerformed = 'TaskPerformed',
  TeamsItemsRestoreCompleted = 'TeamsItemsRestoreCompleted',
  TeamsItemsRestoreInitiated = 'TeamsItemsRestoreInitiated'
}
